import { API_BASE_URL, ACCESS_TOKEN } from '../constants/index.js';
import { request, textrequest, sjRequest, textRequest, jsonSuccessFailureRequest } from './APIUtils.js';

export function viewValuesAnnotations(id, page, mode, annotators, filter) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  // var annotatorUuids = annotators.join(",")

  return request({
    url: API_BASE_URL + "/annotation-edit-group/view/" + id
      + "?page=" + page
      + "&mode=" + mode,
    body: JSON.stringify(filter),
    method: 'POST',
  })
}

export function checkFilter(filter) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  // var annotatorUuids = annotators.join(",")

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/annotation-edit-group/check-filter",
    body: JSON.stringify(filter),
    method: 'POST',
  })
}

export function setAnnotationEditGroupAutoexportable(id, autoexportable) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var object = { autoexportable }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/annotation-edit-group/update/" + id,
    body: JSON.stringify(object),
    method: 'POST',
  });
}

export function scoreValidationDistribution(id, accuracy) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return request({
    url: API_BASE_URL + "/annotation-edit-group/score-validation-distibution/" + id + "?accuracy=" + accuracy,
    method: 'GET'
  })
}

export function downloadAnnotationValues(id, serialization, onlyReviewed, onlyNonRejected, onlyFresh, created, creator, score, scope, selector, model, archive) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return sjRequest({
    url: API_BASE_URL + "/annotation-edit-group/export-annotations-validations/" + id +
        "?serialization=" + serialization +
        "&onlyReviewed=" + onlyReviewed +
        "&onlyNonRejected=" + onlyNonRejected +
        "&onlyFresh=" + onlyFresh +
        "&created=" + created +
        "&creator=" + creator +
        "&score=" + score +
        "&scope=" + scope +
        "&selector=" + selector +
        // "&defaultScope=" + defaultScope +
        "&archive=" + archive +
        "&model=" + model,
    method: 'GET',
  })
}


export function getAnnotationEditGroupsByUser(datasetId) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/annotation-edit-group/get-all-my?datasetId=" + datasetId,
    method: 'GET',
  })
}

export function getAnnotationEditGroups(datasetUri) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/annotation-edit-group/get-all?datasetUri=" + encodeURIComponent(datasetUri),
    method: 'GET',
  })
}

export function viewAnnotationEditsExecution(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return textRequest({
    url: API_BASE_URL + "/annotation-edit-group/lastExecution/" + id,
    method: 'GET'
  });
}

export function commitAnnotationEdits(id, edits) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/annotation-edit-group/commit-edits/" + id,
    body: JSON.stringify(edits),
    method: 'POST',
  })
}
